import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import { loadLeaderboard } from '../utils/farmApi.mjs';
import { mapFarmError } from '../utils/farmState.mjs';

export default {
  oninit(vnode) {
    this.rankingView = 'level';
    this.loading = true;
    this.error = '';
    this.rows = [];
    this.load(vnode);
  },
  load(vnode) {
    this.loading = true;
    return loadLeaderboard(vnode.attrs.app, { view: this.rankingView }, vnode.attrs.basePath)
      .then((response) => { const data = response?.data || response || {}; this.rows = data.rows || []; this.error = ''; })
      .catch((error) => { this.error = mapFarmError(error); })
      .finally(() => { this.loading = false; m.redraw(); });
  },
  view(vnode) {
    return (
      <section className="YingtaoFarmPanel" aria-labelledby="yingtao-leaderboard-title">
        <header className="YingtaoFarmPanel-header">
          <h2 id="yingtao-leaderboard-title">排行榜</h2>
          <div className="YingtaoLeaderboardTabs">
            <Button className={`Button Button--link${this.rankingView === 'level' ? ' is-active' : ''}`} onclick={() => { this.rankingView = 'level'; this.load(vnode); }}>等级总榜</Button>
            <Button className={`Button Button--link${this.rankingView === 'weekly' ? ' is-active' : ''}`} onclick={() => { this.rankingView = 'weekly'; this.load(vnode); }}>本周金币增长</Button>
          </div>
        </header>
        {this.error ? <div className="Alert Alert--error" role="alert">{this.error}</div> : null}
        {this.loading ? <LoadingIndicator /> : this.rows.length ? <ol className="YingtaoLeaderboardList">{this.rows.map((row) => <li key={row.rank}><span>#{row.rank} {row.user?.nickname || '-'}</span><strong>{this.rankingView === 'weekly' ? `${row.coinsGained || 0} 金币` : `等级 ${row.level || 1}`}</strong></li>)}</ol> : <Placeholder text="还没有榜单数据。" />}
      </section>
    );
  },
};
